import { CONTRACT_STATUSES, type CommitmentVsUsageReportItem } from '@vy/types';
import { useMemo } from 'react';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import {
  buildCustomerFilterField,
  buildPlanFilterField,
  collectIdNameOptions,
  collectUniqueOptions,
  filterNonEmptySelectFields,
  MULTISELECT_OPERATORS,
} from '../../reports-components/shared-filter-fields';
import { formatResetCycle } from '../commitment-vs-usage-report-components/commitment-vs-usage-format-helpers';
import { COMMITMENT_VS_USAGE_FILTER_FIELD_IDS } from '../utils/commitment-vs-usage-filter-field-ids';

export function useCommitmentVsUsageFilterFields(
  reportItems: CommitmentVsUsageReportItem[],
): FilterField[] {
  return useMemo(() => {
    const customers = collectIdNameOptions(
      reportItems.map((item) => ({ id: item.customer.id, name: item.customer.name })),
    );
    const plans = collectUniqueOptions(reportItems.map((item) => item.contract.name));
    const resetCycles = collectUniqueOptions(
      reportItems.map((item) => formatResetCycle(item.commitment.resetIntervalMonths)),
    );

    const allFields: FilterField[] = [
      buildCustomerFilterField(customers),
      buildPlanFilterField(plans),
      {
        id: COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.ContractStatus,
        label: 'Contract Status',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: Object.values(CONTRACT_STATUSES).map((status) => ({ value: status, label: status })),
      },
      {
        id: COMMITMENT_VS_USAGE_FILTER_FIELD_IDS.ResetCycle,
        label: 'Reset Cycle',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: resetCycles,
      },
    ];

    return filterNonEmptySelectFields(allFields);
  }, [reportItems]);
}
